/* eslint-disable react/prop-types */
import { h } from 'preact';

import Wrapper from '../../components/1-foundation/wrapper/wrapper';

export const LatestNewsWrapper = ({ children, isRail = false }) => (
  <Wrapper isWrapping={isRail} className="c-rail-content c-rail-content--latestnews">
    {children}
  </Wrapper>
);

export const LatestNewsBody = ({ children, isRail = false }) =>
  isRail ? (
    <div className="c-rail-content__body">{children}</div>
  ) : (
    <div className="l-inner-grid">
      <div className="l-inner-grid__main">{children}</div>
    </div>
  );

export const LatestNewsTop = ({ children }) => <div className="c-rail-content__top">{children}</div>;
